module.exports = __webpack_public_path__ + "media/fonts/gravity-bold-835b86c56694cc88fd6417c886452542.ttf";